import React, { useState, useEffect } from 'react';
import { Redirect, useHistory } from 'react-router-dom';

import apiCall from '../../Utils/apiCall';

import { displayDate } from '../../Utils/dateFormatUtils';
import { searchObjInArray } from '../../Utils/arrayUtils';
import { displayQuoteNumber } from '../../Utils/displayQuoteNumber';

import './QuotesDataTable.css';

import {
	Button,
	Dropdown,
	Search,
	DataTableSkeleton,
	DataTable,
	Table,
	TableBatchAction,
	TableBatchActions,
	TableBody,
	TableCell,
	TableContainer,
	TableExpandHeader,
	TableExpandRow,
	TableExpandedRow,
	TableHead,
	TableHeader,
	TableRow,
	TableSelectAll,
	TableSelectRow,
	TableToolbar,
	TableToolbarAction,
	TableToolbarContent,
	TableToolbarSearch,
	TableToolbarMenu,
	OverflowMenu,
	OverflowMenuItem,
	ToastNotification,
} from 'carbon-components-react';

import { Upload20, Download20 } from '@carbon/icons-react';

function InventoryTable(props) {
	//set history
	const history = useHistory();
	//get props
	const { token, quotesData, loading, refreshData, setQuoteToEdit, setSalesOrderToEdit } = props;
	//define state
	const [dataDisplay, setDataDisplay] = useState(null);
	const [notification, setNotification] = useState(false);
	const [notificationContent, setNotificationContent] = useState({
		title: '',
		caption: '',
		type: 'info',
	});

	// console.log("PROPPI", props); //DEBUG

	//when component mounts, tidy up the data and set state to the props value
	useEffect(() => {
		if (quotesData) {
			const formattedQuotesData = quotesData.map((quote) => {
				let quoteFlat = {};
				quoteFlat.id = quote._id;
				quoteFlat.quoteNumber = quote.quoteNumber;
				quoteFlat.toName = quote.to.name;
				// as per the latest requirement @tanishqsh
				quoteFlat.salesPerson = quote.from.name;
				quoteFlat.createdAt = quote.created_at;
				quoteFlat.expiration = quote.expiration;
				quoteFlat.liveLink = `/quote/${quote._id}`;
				quoteFlat.actions = true;
				return quoteFlat;
			});
			setDataDisplay(formattedQuotesData);
		}
	}, []);

	//define headers for the datatable
	let headers = [
		{
			key: 'quoteNumber',
			header: 'Quote Number',
		},
		{
			key: 'toName',
			header: 'Customer',
		},
		{
			key: 'salesPerson',
			header: 'Sales Person',
		},
		{
			key: 'createdAt',
			header: 'Date Created',
		},
		{
			key: 'expiration',
			header: 'Date Expires',
		},
		{
			key: 'liveLink',
			header: 'Live Quote Link',
		},
		{
			key: 'actions',
			header: 'Actions',
		},
	];

	// handler functions
	const _handleEditItem = (quoteId) => {
		console.log('EDITING QUOTE ID:', quoteId);
		console.log(quotesData);
		let quoteSelected = searchObjInArray(quoteId, '_id', quotesData);
		console.log('!!!', quoteSelected);
		setQuoteToEdit(quoteSelected);
		history.push('/quote-editor');
	};

	const _handleDuplicateItem = async (quoteId) => {
		console.log('duplicating', quoteId);
		let quoteSelected = searchObjInArray(quoteId, '_id', quotesData);
		console.log('!!!', quoteSelected);

		let quoteObject = {};

		quoteObject.items = quoteSelected.items;
		quoteObject.contactInfo = { to: quoteSelected.to, from: quoteSelected.from };
		quoteObject.quoteExtraInfo = { expiration: quoteSelected.expiration };
		quoteObject.contactInfo.from.email = quoteSelected.from.email;
		console.log('QUOTE READY:', quoteObject);

		//CALL API AND SAVE QUOTE

		const options = {
			method: 'POST',
			body: JSON.stringify(quoteObject),
		};
		const headers = {
			'Content-Type': 'application/json',
		};
		const apiPath = '/quotes';

		const result = await apiCall(token, apiPath, options, headers);

		console.log('>>>>>>>', result);
		if (result.err || result.error) {
			setNotificationContent({
				title: 'Error',
				caption: 'Error duplicating quote.',
				type: 'error',
			});
			setNotification(true);
			return;
		}

		setNotificationContent({
			title: 'Success',
			caption: 'Quote succesfully duplicated.',
			type: 'success',
		});
		setNotification(true);

		setTimeout(() => {
			setNotification(false);
			refreshData();
		}, 2500);
	};

	const _handleDeleteItem = async (quoteId) => {
		console.log('deleting, quote', quoteId);

		let confirmed = window.confirm(`Are you sure you want to delete this quote?`);
		if (confirmed === false) return;

		//CALL API AND DELETE QUOTE

		const options = {
			method: 'DELETE',
		};
		const headers = {};
		const apiPath = `/quotes/${quoteId}`;

		const result = await apiCall(token, apiPath, options, headers);

		console.log('>>>>>>>', result);
		if (result.err || result.error) {
			setNotificationContent({
				title: 'Error',
				caption: result.err,
				type: 'error',
			});
			setNotification(true);
			return;
		}

		setNotificationContent({
			title: 'Success',
			caption: result.message,
			type: 'success',
		});
		setNotification(true);

		setTimeout(() => {
			setNotification(false);
			refreshData();
		}, 2500);
	};

	const _handleSalesOrderCreation = (quoteId) => {
		console.log('CREATING SALES ORDER FROM ID:', quoteId);
		console.log(quotesData);
		let quoteSelected = searchObjInArray(quoteId, '_id', quotesData);
		console.log('!!!', quoteSelected);
		let itemsProcessed = quoteSelected.items.map((item) => {
			let newItem = item;
			newItem.quantity = null;
			return newItem;
		});
		quoteSelected.items = itemsProcessed;
		setSalesOrderToEdit(quoteSelected);
		history.push('/sales-order-creator');
	};

	// if datadisp is empty, render the loading animation
	if (!dataDisplay) {
		return (
			<div id="skeletonDataTableCont">
				<DataTableSkeleton showToolbar={false} id="skeletonTable"></DataTableSkeleton>
			</div>
		);
	}

	// render the datatable in its full splendor
	return (
		<div id="quotesTableContainer">
			{notification ? (
				<ToastNotification
					lowContrast={true}
					className="appNotification slide-in-top"
					title={notificationContent.title}
					kind={notificationContent.type}
					caption={notificationContent.caption}
				/>
			) : null}
			<div id="dataTableContainer">
				<DataTable
					rows={dataDisplay}
					headers={headers}
					isSortable
					render={({
						rows,
						headers,
						getHeaderProps,
						getSelectionProps,
						getToolbarProps,
						getBatchActionProps,
						getRowProps,
						onInputChange,
						selectedRows,
						getTableProps,
						getTableContainerProps,
					}) => {
						return (
							<>
								{/*}
            <div id="dataActionsContainer">

            <Search labelText={"inventory search"} onChange={onInputChange} id="inventorySearchBar" placeHolderText={"Search Inventory"} />

            <Button id="refresh-data-button" onClick={() => handleRefreshData() }>
              Refresh
            </Button>

            </div>
            {*/}

								<TableContainer title="DataTable" description="Use the toolbar menu to interact with it" {...getTableContainerProps()}>
									<Table {...getTableProps()}>
										<TableHead>
											<TableRow>
												{headers.map((header, i) => {
													return (
														<TableHeader key={i} {...getHeaderProps({ header })}>
															{header.header}
														</TableHeader>
													);
												})}
											</TableRow>
										</TableHead>
										<TableBody>
											{rows.map((row) => (
												<React.Fragment key={row.id}>
													<TableRow {...getRowProps({ row })}>
														{row.cells.map((cell) => {
															if (cell.info.header === 'quoteNumber') {
																return <TableCell key={cell.id}>{displayQuoteNumber(cell.value)}</TableCell>;
															}

															if (cell.info.header === 'liveLink') {
																return (
																	<TableCell key={cell.id}>
																		<a href={cell.value}>http://portal.cwcdirect.com{cell.value}</a>
																	</TableCell>
																);
															}

															if (cell.info.header === 'expiration' || cell.info.header === 'createdAt') {
																const formattedData = displayDate(cell.value);
																return <TableCell key={cell.id}>{formattedData}</TableCell>;
															}

															if (cell.info.header === 'actions') {
																return (
																	<TableCell key="actionsDropdown" className="bx--table-column-menu">
																		<OverflowMenu flipped>
																			<OverflowMenuItem
																				id="salesOrderItemBtn"
																				onClick={() => _handleSalesOrderCreation(row.id)}
																				itemText="Create Sales Order"
																			></OverflowMenuItem>
																			<OverflowMenuItem
																				onClick={() => _handleEditItem(row.id)}
																				itemText="Modify Quote"
																			></OverflowMenuItem>
																			<OverflowMenuItem
																				onClick={() => _handleDuplicateItem(row.id)}
																				itemText="Duplicate Quote"
																			></OverflowMenuItem>
																			<OverflowMenuItem
																				onClick={() => _handleDeleteItem(row.id)}
																				isDelete
																				itemText="Delete Item"
																			></OverflowMenuItem>
																		</OverflowMenu>
																	</TableCell>
																);
															}

															return <TableCell key={cell.id}>{cell.value.toUpperCase()}</TableCell>;
														})}
													</TableRow>
												</React.Fragment>
											))}
										</TableBody>
									</Table>
								</TableContainer>
							</>
						);
					}}
				/>
			</div>
		</div>
	);
}

export default InventoryTable;
